import { html } from '@rxdi/lit-html';

export function InputErrorTemplate(input: HTMLInputElement) {
  if (input && !input.checkValidity()) {
    input.classList.add('is-invalid');
    return html` <div style="color:red; font-size: 13px;">${input.validationMessage}</div> `;
  }
  input?.classList?.remove('is-invalid');
  return '';
}
